import React from "react";
import Logo from "../../assets/logo.svg";
import { Button } from "@mui/material";
const GlobalErrorPage = ({ statusCode }) => {
  const handleRefresh = () => {
    // Performs a hard refresh from the server
    window.location.reload(true);
  };

  return (
    <div className="page-col" id="error-view">
      <div className="error-top">
        <img src={Logo} alt="Assessive Logo" className="nav-logo" />
        <h1 className="status-code mb-0"> {statusCode || 500}</h1>
      </div>
      <div className="error-middle">
        <p className="mb-0">There was a problem trying to reach this page.</p>
        <p className="mb-0">Refresh below and try again.</p>
      </div>
      <div className="error-bottom">
        <Button onClick={handleRefresh} variant="contained" disableElevation className="px-4" color="error">
          Refresh
        </Button>{" "}
      </div>
    </div>
  );
};

export default GlobalErrorPage;
